<template>
  <table
    class="unstriped hover pega-table pega-table-preview-top"
    data-test="job-own-table"
  >
    <thead>
      <tr>
        <th class="center">
          優先選択
        </th>
        <th class="center">
          選考プロセス
        </th>
        <th class="center">
          独自質問
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>企業情報</th>
        <td
          class="boss-table-data center"
          data-test="unuse-job-own-recruit-process"
        >
          {{ !jobInfo.useJobOwnRecruitProcess | toSign }}
        </td>
        <td
          class="boss-table-data center"
          data-test="unuse-job-own-original-question"
        >
          {{ !jobInfo.useJobOwnOriginalQuestion | toSign }}
        </td>
      </tr>
      <tr>
        <th>職種情報</th>
        <td
          class="boss-table-data center"
          data-test="use-job-own-recruit-process"
        >
          {{ jobInfo.useJobOwnRecruitProcess | toSign }}
        </td>
        <td
          class="boss-table-data center"
          data-test="use-job-own-original-question"
        >
          {{ jobInfo.useJobOwnOriginalQuestion | toSign }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  filters: {
    toSign (val) {
      return val ? '●' : ''
    }
  },
  props: {
    jobInfo: {
      type: Object,
      required: true
    }
  }
}
</script>
